import { User, UserLock } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Header = ({ title, showBack = false, showPersonel = false }) => {
  const navigate = useNavigate()

  return (
    <div className='bg-[#AC5E2A] text-white p-4 flex items-center justify-between sticky top-0 shadow-md z-10'>
      {showBack && (
        <button onClick={() => navigate(-1)} className='hover:bg-white/10 p-1 rounded'>
          <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 19l-7-7 7-7' />
          </svg>
        </button>
      )}
      <h1 className='text-xl font-bold'>{title}</h1>
      {showPersonel ? (
        <button onClick={() => navigate(-1)} className='hover:bg-white/10 p-1 rounded'>
          <UserLock />
        </button>
      ) : (
        <div></div>
      )}
    </div>
  )
}

export default Header
